var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretBlack = function SvgCaretBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.598.254 6.305 4.547 2.012.254.598 1.668l5.707 5.707 5.707-5.707L10.598.254Z"
  })));
};
export { SvgCaretBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEwLjU5NzcgMC4yNTM5MDZMNi4zMDQ2NiA0LjU0NjkxTDIuMDExNjYgMC4yNTM5MDZMMC41OTc2NTYgMS42Njc5MUw2LjMwNDY2IDcuMzc0OTFMMTIuMDExNyAxLjY2NzkxTDEwLjU5NzcgMC4yNTM5MDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";